import React, { useEffect } from 'react'
import { useSelector, useStore } from 'react-redux'
import { useParams } from 'react-router-dom'
import { 
    action_fetch_product_vo,
    action_fetch_product_discount_message, 
    action_fetch_product_summary, 
    action_fetch_product_menus, 
    action_fetch_ab, 
    action_fetch_promotions, 
    action_fetch_product_taglia,
    action_fetch_clearpay,
} from '../../../../store/actions/pages/product'

import NormalPage from './website-page/normal-page'
// import BellePage from './website-page/belle-page'
import Cache from '../../../../utils/cache'
import { useQuery } from '../../../hooks/common'


const ProductPage = props => {
    const params = useParams();
    const store = useStore();
    const query = useQuery();
    const global = useSelector(state => state.global)
    const pageProduct = useSelector(state => state.pageProduct)
    const { productVO } = pageProduct;
    // console.log(pageProduct)
    // <button onClick={() => dispatch(setShowSizeChart(true))}>click</button>

    useEffect(() =>{
        let recentlyProducts = Cache.get("recently_view_products");
        let productId = params?.id;
        if(recentlyProducts?.length > 0){
            let newValues = recentlyProducts.filter(item=>item !== productId);
            if(recentlyProducts?.length < 60){
                Cache.set("recently_view_products", [productId, ...newValues], (365 * 24 * 60 * 60) * 1000);
            }else{
                let sliceArrs = [productId, ...newValues].slice(0, 60);
                Cache.set("recently_view_products", sliceArrs, (365 * 24 * 60 * 60) * 1000);
            }
        }else{
            Cache.set("recently_view_products", [productId], (365 * 24 * 60 * 60) * 1000);
        }


        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			if(productVO?.selectedProductId !== params?.id){
                ProductPage.fetchData(store, params, query, null)
            }
		}
    }, [params?.id, query.color]);

    return (
        productVO?.products?.length > 0 ?
            (<NormalPage {...props}/>): (<div></div>)
    )
}


ProductPage.fetchData = async (store, params, search, headers) => {
    const id = params.id || search?.productId
    const isGift = search?.product_type == 'gift'
    const isAddOn = search?.product_type == 'addOn'
    const saop=search?.saop;
    const isAdp = search?.utm_source
    let params1 = isAddOn ? {type: 2}: isGift ? {type:1}: isAdp? {}: null
    if(isAdp){
        params1.utm_source = isAdp
    }
    if(saop){
        params1={...params1,saop}
    }
    const fetchProduct = store.dispatch(action_fetch_product_vo(id, params1, headers))
    const fetchReivewSummary = store.dispatch(action_fetch_product_summary(id, headers))
    const fetchCategories = store.dispatch(action_fetch_product_menus(id, headers))
    const fetchDiscountMessage = store.dispatch(action_fetch_product_discount_message(headers))
    const fetchAb = store.dispatch(action_fetch_ab(headers))
    // const fetchPromotions = store.dispatch(action_fetch_promotions(id, headers))
    const fetchClearpay = store.dispatch(action_fetch_clearpay(headers))
    const fetchTaglia = store.dispatch(action_fetch_product_taglia(id, headers))
    const values = await Promise.all([fetchProduct, fetchReivewSummary, fetchCategories, fetchDiscountMessage, fetchAb, fetchClearpay, fetchTaglia])
	return values
}

export default ProductPage